

export const handleInput = ( e, setState, values ) => {
  const {name, value} = e.target;
  setState({...values, [name]:value});
}
